import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "height"
const HeightIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 20.813v1.875h-15v-1.875zM16.038 8.337l-1.326 1.326-1.774-1.774v8.222l1.774-1.774 1.326 1.326L12 19.701l-4.038-4.038 1.326-1.326 1.774 1.774V7.89L9.289 9.663 7.962 8.337 12 4.299zM19.5 1.313v1.875h-15V1.312z" />
        </svg>
      }
    </span>
  )
}
export default HeightIcon
